export const FareCalculator = (distance,time,rateDetails,instructionData, decimal, zones, polypoints, settings)=>{  

    function checkIntersection(point, vs) {
        var x = point[0], y = point[1];
        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i][0], yi = vs[i][1];
            var xj = vs[j][0], yj = vs[j][1];
            
            var intersect = ((yi > y) !== (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    }

    let baseCalculated = 0;
    const initial_units = parseFloat(rateDetails.initial_units)>0 ? parseFloat(rateDetails.initial_units) : 0;
    const intial_rate = parseFloat(rateDetails.intial_rate);
    const actual_distance = parseFloat(distance);
    const rate_per_unit_distance = parseFloat(rateDetails.rate_per_unit_distance);

    if(initial_units>0){
        baseCalculated = intial_rate;
    }

    baseCalculated =  baseCalculated + (actual_distance > initial_units? (rate_per_unit_distance * (actual_distance - initial_units)) : 0);

    baseCalculated =  baseCalculated + (parseFloat(rateDetails.rate_per_hour) * (parseFloat(time) / 3600));

    if(rateDetails.base_fare>0){
        baseCalculated = baseCalculated + rateDetails.base_fare;
    }
    if(instructionData && instructionData.parcelTypeSelected){
        baseCalculated = baseCalculated + instructionData.parcelTypeSelected.amount;
    }
    if(instructionData && instructionData.optionSelected){
        baseCalculated = baseCalculated + instructionData.optionSelected.amount;
    }

    let total = baseCalculated > parseFloat(rateDetails.min_fare) ? baseCalculated : parseFloat(rateDetails.min_fare);

    if(rateDetails.peak_hours && rateDetails.peak_hours.length>0){
        for(let i=0; i<rateDetails.peak_hours.length;i++){
            let peakRow = rateDetails.peak_hours[i];
            
            // Check if this is new combined datetime format (start_datetime, end_datetime)
            if(peakRow.start_datetime && peakRow.end_datetime) {
                const startDateTime = new Date(peakRow.start_datetime);
                const endDateTime = new Date(peakRow.end_datetime);
                const currentDateTime = new Date();
                
                // If useFullDateTimePeakHour is false, force to daily type (only check time)
                const useFullDateTime = settings?.useFullDateTimePeakHour !== false; // Default true if not set
                const type = useFullDateTime ? (peakRow.type || 'yearly') : 'daily';
                
                let shouldApplySurge = false;
                
                switch(type) {
                    case 'daily':
                        // Daily recurring - check only time (ignore date)
                        const startTime = startDateTime.getHours() * 60 + startDateTime.getMinutes();
                        const endTime = endDateTime.getHours() * 60 + endDateTime.getMinutes();
                        const currentTimeMinutes = currentDateTime.getHours() * 60 + currentDateTime.getMinutes();
                        
                        if(currentTimeMinutes >= startTime && currentTimeMinutes < endTime) {
                            shouldApplySurge = true;
                            console.log('🕐 Daily peak hour surge applied:', peakRow.price_surge + '%');
                        }
                        break;
                        
                    case 'weekly':
                        // Weekly recurring - check day of week and time
                        const startDay = startDateTime.getDay(); // 0 = Sunday, 1 = Monday, etc.
                        const currentDay = currentDateTime.getDay();
                        const startTimeWeekly = startDateTime.getHours() * 60 + startDateTime.getMinutes();
                        const endTimeWeekly = endDateTime.getHours() * 60 + endDateTime.getMinutes();
                        const currentTimeMinutesWeekly = currentDateTime.getHours() * 60 + currentDateTime.getMinutes();
                        
                        if(currentDay === startDay && 
                           currentTimeMinutesWeekly >= startTimeWeekly && 
                           currentTimeMinutesWeekly < endTimeWeekly) {
                            shouldApplySurge = true;
                            console.log('📅 Weekly peak hour surge applied:', peakRow.price_surge + '%');
                        }
                        break;
                        
                    case 'monthly':
                        // Monthly recurring - check day of month and time
                        const startDayOfMonth = startDateTime.getDate();
                        const currentDayOfMonth = currentDateTime.getDate();
                        const startTimeMonthly = startDateTime.getHours() * 60 + startDateTime.getMinutes();
                        const endTimeMonthly = endDateTime.getHours() * 60 + endDateTime.getMinutes();
                        const currentTimeMinutesMonthly = currentDateTime.getHours() * 60 + currentDateTime.getMinutes();
                        
                        if(currentDayOfMonth === startDayOfMonth && 
                           currentTimeMinutesMonthly >= startTimeMonthly && 
                           currentTimeMinutesMonthly < endTimeMonthly) {
                            shouldApplySurge = true;
                            console.log('📅 Monthly peak hour surge applied:', peakRow.price_surge + '%');
                        }
                        break;
                        
                    case 'yearly':
                        // Yearly - check only date (ignore time), recurring every year
                        const startDateOnly = startDateTime.toISOString().split('T')[0]; // YYYY-MM-DD
                        const endDateOnly = endDateTime.toISOString().split('T')[0];
                        const currentDateOnly = currentDateTime.toISOString().split('T')[0];
                        
                        // Extract month and day from start/end dates
                        const startMonthDay = startDateOnly.substring(5); // MM-DD
                        const endMonthDay = endDateOnly.substring(5); // MM-DD
                        const currentMonthDay = currentDateOnly.substring(5); // MM-DD
                        
                        if(currentMonthDay >= startMonthDay && currentMonthDay <= endMonthDay) {
                            shouldApplySurge = true;
                            console.log('📅 Yearly peak hour surge applied:', peakRow.price_surge + '%');
                        }
                        break;
                        
                    case 'onetime':
                        // One-time - check full date and time range (only once)
                        if(currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
                            shouldApplySurge = true;
                            console.log('📅 One-time peak hour surge applied:', peakRow.price_surge + '%');
                        }
                        break;
                }
                
                if(shouldApplySurge) {
                    total = total + (total * parseFloat(peakRow.price_surge)/100);
                }
            } else if(peakRow.start_date && peakRow.end_date) {
                // Legacy one-time peak hour with separate date and time - treat as yearly
                const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
                const currentTime = new Date().toTimeString().slice(0, 5);  // HH:MM
                
                // Check if current date is within the date range
                if(currentDate >= peakRow.start_date && currentDate <= peakRow.end_date) {
                    // Check if current time is within the time range
                    if(currentTime >= peakRow.start_time && currentTime <= peakRow.end_time) {
                        total = total + (total * parseFloat(peakRow.price_surge)/100);
                        console.log('📅 Legacy one-time peak hour surge applied:', peakRow.price_surge + '%');
                    }
                }
            } else if(peakRow.start_time && peakRow.end_time) {
                // Legacy timestamp-based peak hours - check if it's timestamp or time string
                const startTime = peakRow.start_time;
                const endTime = peakRow.end_time;
                
                // Check if it's a timestamp (number or string of digits)
                if((typeof startTime === 'number' && startTime > 1000000000000) || 
                   (typeof startTime === 'string' && /^\d+$/.test(startTime) && parseInt(startTime) > 1000000000000)) {
                    // Legacy timestamp format - treat as one-time peak hour with full datetime
                    const currentDateTime = new Date();
                    const startDateTime = new Date(parseInt(startTime));
                    const endDateTime = new Date(parseInt(endTime));
                    
                    if(currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
                        total = total + (total * parseFloat(peakRow.price_surge)/100);
                        console.log('🕐 Legacy timestamp peak hour surge applied:', peakRow.price_surge + '%');
                    }
                } else {
                    // Legacy time-based peak hours (daily recurring) - treat as daily type
                    const peak_start_time = (new Date(startTime).getHours() * 60) + new Date(startTime).getMinutes();
                    const peak_end_time = (new Date(endTime).getHours() * 60) + new Date(endTime).getMinutes();
                    const cur_time = (new Date().getHours() * 60) + new Date().getMinutes();
                    if(cur_time >= peak_start_time && cur_time < peak_end_time){
                        total = total + (total * parseFloat(peakRow.price_surge)/100);
                        console.log('🕐 Legacy daily peak hour surge applied:', peakRow.price_surge + '%');
                    }
                }
            }
        }  
    }

    if(zones && zones.length > 0){
        for(let i=0; i < zones.length; i++){
            if(zones[i].zone_path && zones[i].active){
                for(let j=0; j<polypoints.length;j++){
                    if(checkIntersection(polypoints[j], zones[i].zone_path)){
                        total = total + zones[i].zone_surge;
                        break;
                    }
                }
            }
        }
    }

    let convenienceFee = 0;
    if(rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat'){
        convenienceFee = rateDetails.convenience_fees;
    }else{
        convenienceFee = (total*parseFloat(rateDetails.convenience_fees)/100);
    }
    let grand = total + convenienceFee;

    return {
        totalCost:parseFloat(total.toFixed(decimal)),
        grandTotal:parseFloat(grand.toFixed(decimal)),
        convenience_fees:parseFloat(convenienceFee.toFixed(decimal))
    }
     
}
